export default __webpack_public_path__ + "static/media/create-trustline-step-2@3x.2d303f60.png";